import { render, staticRenderFns } from "./Audiencias.vue?vue&type=template&id=2eeced02&scoped=true"
import script from "./Audiencias.vue?vue&type=script&lang=js"
export * from "./Audiencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeced02",
  null
  
)

export default component.exports